<template>
  <div class="invite-code-tab">
    <InviteCodeInputSection
      :inputCode="inputCode"
      :hasError="hasError"
      :errorMessage="errorMessage"
      :isAlreadyReferred="isAlreadyReferred"
      :notEligible="notEligible"
      :rewardStatus="rewardStatus"
      @input="onInput"
      @submit="$emit('submit')"
    />
    <InviteCodeGuide />
  </div>
</template>

<script>
import InviteCodeInputSection from '@/components/new/organisms/InviteCodeInputSection.vue'
import InviteCodeGuide from '@/components/new/organisms/InviteCodeGuide.vue'

export default {
  name: 'InviteCodeTab',
  components: {
    InviteCodeInputSection,
    InviteCodeGuide,
  },
  props: {
    inputCode: {
      type: String,
      default: '',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    isAlreadyReferred: {
      type: Boolean,
      default: false,
    },
    notEligible: {
      type: Boolean,
      default: false,
    },
    rewardStatus: {
      type: String,
      default: '',
    },
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteCodeTab.vue